"use client";

import { Separator } from "@/components/ui/separator";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const stats = [{
  value: "100%",
  label: "Recycled Pulp"
}, {
  value: "12M+",
  label: "Bags Produced"
}, {
  value: "0%",
  label: "Plastic Waste"
}, {
  value: "4.8/5",
  label: "Eco-Rating"
}];
export default function InnovatorImpactMetrics() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="223716" id="our-environmental-impact" className="dark bg-background text-foreground relative flex flex-col items-center justify-center py-24 overflow-hidden">
      {}
      <div className="absolute inset-0 pointer-events-none opacity-10" style={{
      backgroundImage: `url('https://wpvc-images.s3.us-east-1.amazonaws.com/images/1669361/img/leaf_watermark.png')`,
      backgroundPosition: 'center',
      backgroundRepeat: 'no-repeat',
      backgroundSize: 'contain'
    }} aria-hidden="true" />

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mb-20">
        <Separator className="bg-border h-1 border-0" />
      </div>

      <div ref={ref} className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 text-center">
          {stats.map((stat, i) => <div key={i} data-index={i} className={`flex flex-col items-center justify-center space-y-4 transition-all duration-1000 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12"}`} style={{
          transitionDelay: `${i * 150}ms`
        }}>
              <div className="relative inline-block">
                {}
                <div className="absolute inset-0 bg-primary/10 blur-3xl rounded-lg scale-150" aria-hidden="true" />
                <span className="relative font-default text-5xl sm:text-6xl lg:text-7xl font-bold text-primary tracking-tighter">
                  {stat.value}
                </span>
              </div>
              <span className="font-mono text-xs sm:text-sm text-muted-foreground uppercase tracking-widest">
                {stat.label}
              </span>
            </div>)}
        </div>
      </div>

      {}
      <div className="w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-20">
        <Separator className="bg-border h-1 border-0" />
      </div>
    </section>;
}